module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar",
    class: _vm.person.hex_color,
    style: ({
      boxShadow: '0 0 0 15px ' + _vm.borderColor
    }),
    attrs: {
      "data-initial": _vm.person.initial
    }
  }, [(_vm.person.profile_photo_url) ? _c('img', {
    attrs: {
      "src": _vm.person.profile_photo_url
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9e2a2dc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = 126
// module chunks = 1